<template>
<div class="min-h-screen bg-gray-50 py-12">
    <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
    <!-- Header -->
    <div class="text-center mb-12">
        <h1 class="text-4xl font-bold text-gray-900 mb-4">Chính sách bảo mật</h1>
        <p class="text-lg text-gray-600">Cập nhật lần cuối: {{ currentDate }}</p>
    </div>

    <!-- Content -->
    <div class="bg-white rounded-lg shadow-lg p-8">
        <div class="prose prose-lg max-w-none">
        <!-- Section 1 -->
        <div class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">1. Thông tin thu thập</h2>
            <p class="text-gray-700 leading-relaxed">
            Chúng tôi thu thập thông tin cá nhân của bạn khi bạn liên hệ để tư vấn dịch vụ thiết kế web, bao gồm:
            </p>
            <ul class="list-disc list-inside mt-4 text-gray-700 space-y-2">
            <li>Họ và tên</li>
            <li>Địa chỉ email</li>
            <li>Số điện thoại</li>
            <li>Thông tin về dự án website</li>
            </ul>
        </div>

        <!-- Section 2 -->
        <div class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">2. Mục đích sử dụng</h2>
            <p class="text-gray-700 leading-relaxed">
            Thông tin cá nhân của bạn được sử dụng để:
            </p>
            <ul class="list-disc list-inside mt-4 text-gray-700 space-y-2">
            <li>Tư vấn và cung cấp dịch vụ thiết kế web</li>
            <li>Liên lạc và trao đổi về dự án</li>
            <li>Gửi báo giá và hợp đồng</li>
            <li>Hỗ trợ kỹ thuật sau khi hoàn thành dự án</li>
            </ul>
        </div>

        <!-- Section 3 -->
        <div class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">3. Bảo mật thông tin</h2>
            <p class="text-gray-700 leading-relaxed">
            Chúng tôi cam kết bảo mật thông tin cá nhân của bạn và không chia sẻ với bên thứ ba 
            trừ khi có yêu cầu từ cơ quan pháp luật hoặc được bạn đồng ý.
            </p>
        </div>

        <!-- Section 4 -->
        <div class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">4. Cookies</h2>
            <p class="text-gray-700 leading-relaxed">
            Website sử dụng cookies để cải thiện trải nghiệm người dùng và phân tích lưu lượng truy cập. 
            Bạn có thể tắt cookies trong trình duyệt nếu không muốn sử dụng.
            </p>
        </div>

        <!-- Section 5 -->
        <div class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">5. Liên hệ</h2>
            <p class="text-gray-700 leading-relaxed">
            Nếu bạn có thắc mắc về chính sách bảo mật này hoặc muốn hủy đăng ký, 
            vui lòng liên hệ với chúng tôi qua email: <span class="font-semibold text-blue-600">contact@webservices.vn</span>
            </p>
        </div>
        </div>
    </div>

    </div>
</div>
</template>

<script setup>
const currentDate = '30/12/2024'
</script>